import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FeedbackCategories, FeedbackHistory } from './feedback.model';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FeedbackService {
    constructor(@Inject('ENV') private env: any, private http: HttpClient) {}

    getFeedbackCategories(lang: string): Observable<FeedbackCategories[]> {
        const url = `${this.env.CORE_API_URL}/customer/v3/customer-requests/categories?lang=${lang}`;
        return this.http.get<FeedbackCategories[]>(url);
    }

    saveFeedback(request: any, lang: string, file: File): Observable<any> {
        const url = `${this.env.CORE_API_URL}/customer/v3/region/${this.env.REGION_ID}/customer-requests?lang=${lang}`;

        const payload = { ...request, category: request.category.code };
        const formData = new FormData();
        const customerRequestBlob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
        formData.append('customerRequest', customerRequestBlob, 'customerRequest.json');
        if (file) {
            formData.append('attachments', file, file.name);
        }

        return this.http.post(url, formData);
    }

    getFeedbackHistory(lang: string): Observable<FeedbackHistory[]> {
        const url = `${this.env.CORE_API_URL}/customer/v3/region/${this.env.REGION_ID}/customer-requests?lang=${lang}`;

        return this.http
            .get<FeedbackHistory[]>(url)
            .pipe(tap((feedbackHistory) => this.sortFeedbackHistory(feedbackHistory)));
    }

    private sortFeedbackHistory(feedbackHistory: FeedbackHistory[]): FeedbackHistory[] {
        return feedbackHistory.sort((a, b) => {
            return a.requestDto.status_id - b.requestDto.status_id;
        });
    }
}
